import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isNil } from 'shared/src/utils';

export const useLogClickBrandHome = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();

  return useCallback(() => {
    if (isNil(goodsBasic)) return;
    if (isNil(goodsBasic.brand)) return;

    logGoodsAnalytics({
      name: 'CLICK_BRAND_HOME',
      analytics: {
        BRAND_NAME: goodsBasic.brand.name,
        BRAND_SNO: goodsBasic.brand.sno.toString(),
        GOODS_SNO: goodsBasic.sno.toString(),
        MARKET_NAME: goodsBasic.market.name,
        MARKET_SNO: goodsBasic.market.sno.toString(),
        MARKET_TYPE: goodsBasic.brand.brand_vertical_type.name,
        MARKET_TYPE_SNO: goodsBasic.brand.brand_vertical_type.sno.toString(),

        TYPE: 'SIMPLE',
      },
    });
  }, [goodsBasic, logGoodsAnalytics]);
};
